import createCore from "@kunsten/core";
export default createCore();
